import { render, staticRenderFns } from "./ParticipantSideBar.vue?vue&type=template&id=0b0b717f&scoped=true&"
import script from "./ParticipantSideBar.vue?vue&type=script&lang=js&"
export * from "./ParticipantSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantSideBar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ParticipantSideBar.vue?vue&type=style&index=1&id=0b0b717f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0b717f",
  null
  
)

export default component.exports